import React from 'react';
import { cn } from '@/lib/utils';
import { colorStyles, cardBase, activeRing } from './KPICard.styles';
import type { KPICardProps } from './KPICard.types';

export const KPICard: React.FC<KPICardProps> = ({
  title,
  value,
  icon: Icon,
  color,
  onClick,
  isActive,
}) => {
  const testId = `kpi-${title.toLowerCase().replace(/\s/g, '-')}`;

  return (
    <div
      data-testid={testId}
      className={cn(
        cardBase,
        colorStyles[color],
        isActive && activeRing
      )}
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
            {title}
          </p>
          <p className="text-2xl font-bold mt-1">{value}</p>
        </div>
        <Icon className="w-8 h-8 opacity-40" />
      </div>
    </div>
  );
};
